/* @flow */

import moment from 'moment';

export default (date: string) => {
    if (!date) return '';

    return moment(date).format('DD/MM/YYYY');
};
